import { RESOURCE_POOL_TYPE } from '../../../typesAndInterfaces/typesAndInterfaces';

export enum BULK_UPLOAD_ITEM_STATUS {
  ready = 'ready',
  uploading = 'uploading',
  success = 'success',
  error = 'error',
}

export interface BulkUploadFile {
  /**
   * Blob is used on web. Undefined on mobile (see MB_ResourcePickerResource).
   */
  blob: Blob | undefined;
  uri: string;
  fileName: string;
}

export interface BulkUploadItem {
  id: string;
  file: BulkUploadFile;
  name: string;
  tags: string[];
  status: BULK_UPLOAD_ITEM_STATUS;
  /**
   * Upload progress percentage (0-100). Only meaningful while status is `uploading`.
   */
  progress: number;
  errorMessage?: string;
  /**
   * True when the server reports an item with this name already exists in the pool.
   */
  isDuplicateOnServer: boolean;
  showNameError: boolean;
  showTagsError: boolean;
}

export interface BulkUploadConfig {
  resourcePoolType: RESOURCE_POOL_TYPE;
  folderId?: string;
}

export const BULK_UPLOAD_MAX_FILES = 20;
export const BULK_UPLOAD_VIDEO_CONCURRENCY = 2;
export const BULK_UPLOAD_IMAGE_CONCURRENCY = 3;
export const BULK_UPLOAD_DUPLICATE_CHECK_DEBOUNCE_MS = 500;
